<div *ngIf="isLoading()" class="spinner-wrapper">
    <nz-spin nzSimple [nzSize]="'large'" nzTip="Loading..."></nz-spin>
</div>